<script>

export default {
  components:{
  },
  props: {
    currentUser: { type: Object },
    currentEmpresa: { type: Object },
    currentPlanoConta: { type: Object },
  },
  data() {
    return {
      loader: {
        get: false
      },
      planoConta:{},
    }
  },
  created(){
    this.planoConta = this.currentPlanoConta
  },
  mounted() {
    this.$emit('newTitle', 'Alterar Plano de Contas')
  },
  computed: {
  },
  methods: {
    setPut() {
      this.$emit('doPut', this.planoConta)
    },
  },
}
</script>

<template>
<div class="card">
    <div class="card-body">
      <div class="row">
        <div class="col-md-6">
          <label for="planoConta-descricao">* Nome</label>
          <input id="planoConta-descricao" v-model="planoConta.descricao" type="text" class="form-control text-left" />
        </div>
        <div class="col-md-2">
          <label for="planoConta-codigo_reduzido">* Código Reduzido</label>
          <input id="planoConta-codigo_reduzido" v-model="planoConta.codigo_reduzido" type="text" class="form-control text-left" />
        </div>
        <div class="col-md-2">
          <label for="planoConta-classificacao">Classificação</label>
          <input id="planoConta-classificacao" v-model="planoConta.classificacao" type="text" class="form-control text-left" />
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-md-2">
          <label for="planoConta-grupo_pgto">* Grupo Pagamento</label>
          <select id="planoConta-grupo_pgto" v-model="planoConta.grupo_pgto" type="text" class="form-control text-left">
            <option value="">Nenhum</option>
            <option value="av">À vista</option>
            <option value="ap">À prazo</option>
          </select>
        </div>
        <div class="col-md-4">
          <label for="planoConta-conta_pgto">* Conta Pagamento</label>
          <select id="planoConta-conta_pgto" v-model="planoConta.conta_pgto" type="text" class="form-control text-left">
            <option value="0">Sim</option>
            <option value="1">Não</option>
          </select>
        </div>
        <div class="col-md-3">
          <label for="planoConta-natureza">* Natureza</label>
          <select id="planoConta-natureza" v-model="planoConta.natureza" type="text" class="form-control text-left">
            <option value="A">Ativo</option>
            <option value="C">Resultado (Crédito)</option>
            <option value="D">Despesas</option>
            <option value="I">Impostos</option>
            <option value="O">Obrigações (Passivo Circulante)</option>
            <option value="P">Pessoal</option>
            <option value="R">Receitas</option>
            <option value="T">Tributos Diversos</option>
          </select>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="col-md-12 mt-10">
        <button class="btn btn-success" @click.prevent="setPut()">
          Gravar
        </button>
        
      </div>
    </div>
  </div>
</template>